import {
  Heading,
  MaterialUICore,
  Button as DSButton,
  axiomTokens,
  Chip as DSChip,
  Body as DSBody,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;

const { border, color, spacing } = axiomTokens;

const justifyContentSpaceBetween = 'space-between';

export const MobileCard = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: `${spacing[4]} ${spacing[4]}`,
  position: 'fixed',
  backgroundColor: color.background[2],
  bottom: 0,
  left: 0,
  transform: 'translateY(-60px)',
  transition: 'all 5s ease-in',
  zIndex: 1,

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const VoucherToggleMobile = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: justifyContentSpaceBetween,
  marginBottom: spacing[3],
});

export const VoucherCollapseWrapperMobile = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: justifyContentSpaceBetween,
  alignItems: 'center',
  marginBottom: spacing[3],
  gap: spacing[4],
});

export const PlanSummaryMobile = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: justifyContentSpaceBetween,
  alignItems: 'center',
});

export const DescriptionTitlePlan = styled(Heading)({
  color: color.typeface.feedback.info,
});

export const Button = styled(DSButton)({
  color: color.typeface.pure,
});

export const ChipWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: justifyContentSpaceBetween,
  marginBottom: spacing[3],
});

export const Chip = styled(DSChip)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    padding: '10px 12px',
  },
}));

export const WarningRemoveVoucherMobile = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
  backgroundColor: color.surface.feedback.warning.subtle,
  padding: spacing[2],
  marginBottom: spacing[3],
  borderColor: color.border.feedback.warning,
  borderStyle: 'solid',
  border: border.width.xs,
  borderRadius: border.radius.sm,
  width: '100%',
});

export const WarningContentMobile = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: spacing[2],
  alignItems: 'center',
});

export const WarningButtonMobile = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'row',
  gap: spacing[3],
  marginTop: spacing[2],
  width: '100%',
  alignItems: 'flex-start',
  paddingRight: spacing[3],
});

export const Body = styled(DSBody)({
  color: color.typeface.feedback.warning,
});
